import { Box, Card, CardContent, Typography, Grid, Autocomplete, TextField, Button, Checkbox, Switch } from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import { updateLogITAccess } from "redux/actions/addEditWorker";

const LogIt = ({handleChange}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const approveForMgr = location.state && location.state.approveForManager
                            ? location.state.approveForManager : {};
  const user = useSelector((state) => state.user.auth.user);
  const logITData = useSelector(state => state.addEditWorker.workerRoles.logIT || {});
  const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
  const imtRole = useSelector((state) => state.user.imtRole || null);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
  const [disableSave, setDisableSave] = useState(true);
  const [logITRoleOptions, setlogITRoleOptions] = useState(["Manager", "Operator"]);
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
    console.log("IMTime Role", imtRole)
    if(imtRole?.userRole?.role){
        if(imtRole?.userRole?.role === "Support"){
          setReadOnly(true);
        }
        else{
          setReadOnly(false)
        }
      }
  },[imtRole])

  useEffect(() => {
    if(logITData && Object.keys(logITData).length>0){
      console.log("logIT logITData", logITData);
      const data = _.cloneDeep(logITData || {});
      setFormValues(data);
    }
  }, [logITData]);

  useEffect(() => {
    console.log("logIT formValues", formValues);
    validForm(formValues);
  } ,[formValues])

  const validForm = (formValues) => {
    let errors = {};
    if(formValues?.isActive){
      if(!formValues?.role){
        errors['role'] = "Field is required";
      }
    }
    setFormErrors(errors);
    const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, logITData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        setSnackControl({
          open: true,
          message: "Invalid data to submit. Please check!",
          severity: "info"
        })
      }

      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        role: formValues?.role || "",
        activityFamilyId: 'logIT',
        isActive: formValues?.isActive ? true : false
      }
      console.log("LogIt submit", formValues, data);
      const response = await dispatch(updateLogITAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "LogIt Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "LogIt Access update failed.",
          severity: 'error'
        })
      }

    }catch(error){
      console.log("LogIt handleSubmit error", error);
      setSnackControl({
        open: true,
        message: "LogIt Access failed to submit.",
        severity: "error"
      })
    }
  }


  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
          
          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)'}}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                LogIT
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    
                    marginBottom={2}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                        inputProps={{ 'aria-label': 'Enable LogIt Role switch' }}
                        checked={formValues.isActive}
                        onChange={(e) => {
                          let checked = e.target.checked;
                          setFormValues({ ...formValues, isActive: checked });
                        }}
                        disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginTop={3}>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                      <Autocomplete
                        renderInput={(params) => (
                          <TextField {...params} 
                          label="Select Role" 
                          required
                          error={formErrors?.role}
                          helperText={formErrors?.role}
                          />
                        )}
                        id="role"
                        name="role"
                        size="small"
                        options={logITRoleOptions}
                        value={formValues?.role || ""}
                        onChange={(e, v)=>{
                          setFormValues(prevState => ({...prevState, role: v ? v : "", additionalPermissions: []}))
                        }}
                        disabled={!formValues?.isActive || readOnly}
                        readOnly={readOnly}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={5}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                      onClick={(e) => handleChange(e,0)}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 30, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled={disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default LogIt;
          